/**
 * Timer_Entity type guard.
 *
 * @param {any} timerJson Timer object from API
 * @returns {boolean} Return true if type is Timer_Entity
 */
function validator(timerJson: unknown): timerJson is Timer_Entity {
  if (typeof timerJson === "object" && timerJson != null) {
    Timer_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(timerJson).includes(element))
        console.log("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Timer_Entity {
  static requiredFields = [
    "id",
    "startDateUTC",
    "endDateUTC",
    "projectID",
    "taskID",
    "userID",
    "notes",
    "projectName",
    "userName",
    "createdAt",
    "updatedAt",
  ];

  constructor(timerJson: unknown) {
    if (validator(timerJson)) {
      this.id = timerJson.id;
      this.startDateUTC = timerJson.startDateUTC;
      this.endDateUTC = timerJson.endDateUTC;
      this.projectID = timerJson.projectID;
      this.taskID = timerJson.taskID;
      this.userID = timerJson.userID;
      this.notes = timerJson.notes;
      this.projectName = timerJson.projectName;
      this.userName = timerJson.userName;
      this.createdAt = timerJson.createdAt;
      this.updatedAt = timerJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Timer_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  startDateUTC: string;
  endDateUTC: string;
  projectID: number;
  taskID: number;
  userID: number;
  notes: string;
  projectName: string;
  userName: string;
  createdAt: string;
  updatedAt: string;
}
